import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

interface UserDetailsStyleProps {
  smallMedia: boolean
}

const useStyles = makeStyles<Theme, UserDetailsStyleProps>(theme => ({
  root: {
    margin: ({ smallMedia }) => (smallMedia ? '1rem' : '0'),
    display: 'flex',
    flexDirection: 'column'
  },

  form: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '0.75rem',

    '& > div': {
      display: 'flex'
    },

    '& > :not(:last-child)': {
      marginBottom: '0.75rem'
    },

    '& > :last-child': {
      marginTop: '0.5rem'
    }
  },

  textField: {
    fontSize: theme.size.sm,
    width: 'calc(100% - 100px)',

    '& .MuiOutlinedInput-root': {
      fontSize: theme.size.sm
    },

    '& .MuiInputLabel-outlined': {
      fontSize: theme.size.sm
    }
  },

  switch: {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-end',

    '& .MuiTypography-body1': {
      fontSize: theme.size.sm
    },

    '& .MuiTypography-body1, & .MuiSwitch-root': {
      marginLeft: '0.75rem'
    }
  },

  error: {
    color: 'red'
  },

  title: {
    flexBasis: '100%',
    color: '#323436',
    fontSize: theme.size.sm,
    alignItems: 'center',
    display: 'flex',
    marginBottom: '10px'
  },

  label: {
    width: '100px',
    display: 'inline-flex',
    cursor: 'default',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    color: '#808080',
    fontSize: theme.size.sm
  },

  icon: {
    marginRight: '5px'
  },

  buttonContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center'
  }
}))

export default useStyles
